import Reveal from "@/components/Reveal";
import { imgUrl } from "@/lib/api";
import { ShieldCheck, Recycle, Users } from "lucide-react";

const ICONS = [ShieldCheck, Recycle, Users];

export default function Rse({ rse }) {
  if (!rse || !rse.items || !rse.items.length) return null;
  return (
    <section className="py-20 md:py-24 bg-citek-greenDark text-white" data-testid="rse-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="font-tech text-sm uppercase tracking-[0.24em] text-citek-greenBright" data-testid="rse-kicker">
            {rse.kicker}
          </p>
          <div className="mt-4 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div className="flex flex-wrap items-center gap-5">
              <h2 className="font-display font-extrabold uppercase tracking-tight text-[1.65rem] md:text-4xl leading-[1.05] min-w-0 break-words" data-testid="rse-title">
                {rse.title}
              </h2>
              {rse.badges && rse.badges.length > 0 ? (
                <div className="flex flex-wrap items-center gap-5 shrink-0" data-testid="rse-badges">
                  {rse.badges.map((b, i) => (
                    <img key={i} src={imgUrl(b.image)} alt={b.name} className="h-28 md:h-36 w-auto object-contain drop-shadow-lg" data-testid={`rse-badge-${i}`} />
                  ))}
                </div>
              ) : (
                <svg viewBox="0 0 96 96" className="h-16 w-16 md:h-20 md:w-20 shrink-0" data-testid="rse-badge" role="img" aria-label="Badge RSE engagée">
                  <circle cx="48" cy="48" r="44" fill="none" stroke="#00C862" strokeWidth="2.5" strokeDasharray="4 5" />
                  <circle cx="48" cy="48" r="35" fill="rgba(0,198,98,0.15)" stroke="#00C862" strokeWidth="1.5" />
                  <text x="48" y="45" textAnchor="middle" fill="#FFFFFF" fontFamily="Syne, sans-serif" fontWeight="800" fontSize="19">RSE</text>
                  <text x="48" y="63" textAnchor="middle" fill="#00C862" fontFamily="'JetBrains Mono', monospace" fontSize="8" letterSpacing="2">ENGAGÉE</text>
                </svg>
              )}
            </div>
            {rse.subtitle && (
              <p className="max-w-md text-base leading-relaxed text-white/80" data-testid="rse-subtitle">
                {rse.subtitle}
              </p>
            )}
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
          {rse.items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div
                  data-testid={`rse-item-${i}`}
                  className="h-full rounded-xl border border-white/20 bg-white/10 p-6"
                >
                  <Icon size={26} className="text-citek-greenBright" />
                  <p className="mt-4 font-display font-bold text-lg" data-testid={`rse-item-title-${i}`}>
                    {it.title}
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-white/80" data-testid={`rse-item-desc-${i}`}>
                    {it.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
